import type { PayloadAction } from '@reduxjs/toolkit';

import { REQUIRE_GDPR_MODAL, SET_COMPLIANCE_LEVEL, type ComplianceLevel } from './types';

const initialState: ComplianceLevel = REQUIRE_GDPR_MODAL;

export function complianceLevelReducer(
	state = initialState,
	action: PayloadAction<ComplianceLevel>,
): ComplianceLevel {
	switch (action.type) {
		case SET_COMPLIANCE_LEVEL:
			return action.payload;
		default:
			return state;
	}
}
